import { defineMessages } from 'react-intl';

import { Switch } from 'atoms/inputs/Switch';
import { useCurrentUserContext } from 'contexts/currentUser';
import { LIFECYCLE, useLifecycle } from 'hooks/useLifecycle';

import { SettingsSection } from '../SettingsSection';

const messages = defineMessages({
  title: {
    id: 'Settings.disable3D.title',
    defaultMessage: '3D preview',
  },
  description: {
    id: 'Settings.disable3D.description',
    defaultMessage: 'Always disable 3D preview',
  },
});

export const Disable3D = () => {
  const { currentUser } = useCurrentUserContext();
  const { update, lifecycle } = useLifecycle();
  const disable3D = lifecycle?.disable3D;

  if (!currentUser) return null;

  return (
    <SettingsSection
      title={messages.title}
      description={messages.description}
      toggleButton={
        <Switch
          checked={disable3D}
          onChange={() => {
            update(LIFECYCLE.disable3D, !disable3D);
          }}
        />
      }
    />
  );
};
